// extracted by mini-css-extract-plugin
export var createdDate = "_ip-1";
export var divider = "_ip-2";
export var headerDivider = "_ip-3";
export var messagesCard = "_ip-0";
export var messagesContainer = "_ip-7";
export var messagesContainerWrapper = "_ip-4";
export var pointerCapturingButtonBoxes = "_ip-a";
export var showLeftPanelButton = "_ip-9";
export var showMoreButton = "_ip-c";
export var showMoreButtonContainer = "_ip-b";
export var summaryTitle = "_ip-6";
export var systemMessageCardWrapper = "_ip-d";
export var topButtons = "_ip-8";
export var withPadding = "_ip-5";